import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChangecontrolPersistenceService } from '../../services/changecontrol-persistence.service';
import { ChangeControlDisplayDetails } from '../../../../change-control/change-control-details/models/change-control-display-details';
import { ChangeControlAttachmentDetails } from '../../../../../app/change-control/change-control-details/models/change-control-attachment-details';
import { ChangeControlLibraryConstants } from '../../constants/changeControlLibraryConstants';
import { ChangeControlPersistenceService } from '../../../change-control-details/services/change-control-persistence.service';


@Component({
  selector: 'app-change-control-slider',
  templateUrl: './change-control-slider.component.html',
  styleUrls: ['./change-control-slider.component.scss'],
})
export class ChangeControlSliderComponent {
  @Output() isChangeControlSliderActive = new EventEmitter<boolean>();
  @Input() isChangeControlSliderOpen: boolean = false;
  @Input() changeControlDetails !: ChangeControlDisplayDetails
  @Output() changeControlDataReload = new EventEmitter<boolean>();
  maxFileSize = ChangeControlLibraryConstants.Attachment_File_Max_Size;
  currentTab = 0;
  activeTab = 0;
  isChangeControlEditSlider = false;
  errorIconClassForTab = '';
  errorIconClassForFilesTab = '';
  fileNamesToSave: any;
  attachmentFileTypes = '';
  attachmentsToSave: File[] = [];
  files: File[] = [];
  @Output() activateTabIndex = new EventEmitter<number>();
  deletedAttachments: ChangeControlAttachmentDetails[] = [];
  showDeletedFilesConfirmationModal = false;
  savedFiles: string[] = [];
  fileNamesForAddAndDeleteOperations: string[] = [];
  changeControlSliderLoader: boolean = false;

  constructor(
    private changecontrolPersistenceService: ChangecontrolPersistenceService,
    private changeControlPersistenceService: ChangeControlPersistenceService
  ) {}
  openCurrentTab = (tabIndex: number) => {
    this.currentTab = tabIndex;
    this.activeTab = tabIndex;
  }
  onTabChange = (event: any) => {
    this.changecontrolPersistenceService.onTabChange(this.currentTab);
    this.changecontrolPersistenceService.onCustomTabChange(event.index);
    this.currentTab = event.index;
  }

  ngOnInit(): void {
    this.changecontrolPersistenceService.changeControlSaveInProgressForSlider$.subscribe(
      (changeControlSaveStatus) => {
        this.changeControlSliderLoader = changeControlSaveStatus;
      }
    );
    this.changecontrolPersistenceService.closeAndResetChangeControlSlider$.subscribe(
      (isClose: boolean) => {
        if (isClose) {
          this.closeAndResetChangeControlSlider();
          this.changeControlDataReload.emit(true);
        }
      }
    );
    this.changecontrolPersistenceService.checkSliderFromChangeControlDetails();
    this.isChangeControlEditSlider = this.changecontrolPersistenceService.isChangeControlEditSlider;
    this.changecontrolPersistenceService.navigateToErrorTabOnSave$.subscribe((tabIndex) => {
      if ( this.isChangeControlEditSlider && tabIndex > 0) {
        this.openCurrentTab(tabIndex);
      }
    });
    this.changecontrolPersistenceService.populateErrorsForTab$.subscribe((validateTabs) => {
      if(validateTabs) {
        this.showErrorIconForTab();
      }
    });
  }

  closeAndResetChangeControlSlider() {
    this.isChangeControlSliderOpen = false;
    this.isChangeControlSliderActive.emit(this.isChangeControlSliderOpen);
    this.resetControls();
    this.changeControlPersistenceService.updateInActionPlanData();
  }

  closeSlider() {
    this.changecontrolPersistenceService.openConfirmationDialog();
  }

  ngOnDestroy = () =>{
    this.changecontrolPersistenceService.closeAndResetChangeControlSlider$.unsubscribe();
    this.changecontrolPersistenceService.changeManagementDetails$.unsubscribe();
    this.changecontrolPersistenceService.changeManagementDisplayDetails$.unsubscribe();
    this.resetControls();
  }

  resetControls(){
    this.changecontrolPersistenceService.changeControlAttachments = []
    this.changecontrolPersistenceService.deletedChangeControlAttachments = []
    this.changecontrolPersistenceService.savedChangeControlAttachments = [];
    this.changecontrolPersistenceService.filesToSave = []
    this.changecontrolPersistenceService.filesToDelete = []
    this.errorIconClassForTab = '';
    this.errorIconClassForFilesTab = '';
  }


  showErrorIconForTab = () => {
    this.errorIconClassForTab = '';
    this.errorIconClassForFilesTab = '';
    this.changecontrolPersistenceService.errorTabIndices.forEach((tabIndex) => {
      switch (tabIndex) {
        case ChangeControlLibraryConstants.ChangeControl_Menu_General_Tab_Index:
          this.errorIconClassForTab = 'pi pi-exclamation-triangle';
          break;
        case ChangeControlLibraryConstants.ChangeControl_Menu_RelatedDocoument_Tab_Index:
          this.errorIconClassForFilesTab = 'pi pi-exclamation-triangle';
          break;
      }
    })
  }
}
